"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_components_1 = require("@securityproducts/core-components");
var React = __importStar(require("react"));
var react_html_parser_1 = __importDefault(require("react-html-parser"));
var download_icon_1 = require("../../../svg/download.icon");
var print_icon_1 = require("../../../svg/print.icon");
var dropdown_1 = require("../dropdown/dropdown");
var description_i18n_1 = require("./description.i18n");
var description_styles_1 = require("./description.styles");
var timezone_1 = require("../timezone/timezone");
function Description(props) {
    function download() {
        props.download({
            fromDate: props.fromDate,
            toDate: props.toDate,
        });
    }
    var hasPrint = !!props.print;
    var strings = core_components_1.useLocalisation(description_i18n_1.descripitonTranslations, props.language);
    var language = props.language ? props.language : core_components_1.getBrowserLanguage();
    var reportTitleString = core_components_1.formatString(strings.reportFor, "<span id=\"desc-agent\">" + props.agent + "</span>");
    var reportTitle = react_html_parser_1.default(reportTitleString);
    return (React.createElement("div", { className: description_styles_1.descriptionContainer },
        React.createElement(core_components_1.ErrorBoundary, null,
            React.createElement("div", { id: "report-description", className: description_styles_1.summary }, props.isHistorical ? (React.createElement("div", { id: "report-info" },
                reportTitle,
                strings.from,
                " ",
                props.fromDate && (React.createElement("span", { id: "desc-fromDate" }, core_components_1.customLocale(props.fromDate, language, {
                    month: "short",
                    day: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                }))),
                " ",
                strings.to,
                " ",
                props.toDate && (React.createElement("span", { id: "desc-toDate" }, core_components_1.customLocale(props.toDate, language, {
                    month: "short",
                    day: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                }))))) : (React.createElement("div", { id: "report-info" },
                reportTitle,
                " ",
                strings.forToday))),
            React.createElement("div", { className: description_styles_1.wrap },
                React.createElement("div", { className: description_styles_1.timezone },
                    React.createElement(timezone_1.Timezone, __assign({}, props.timezone))),
                React.createElement("div", { className: description_styles_1.icons },
                    hasPrint && (React.createElement(core_components_1.Button, { id: "print", onClick: props.print, icon: true, text: true },
                        React.createElement(print_icon_1.PrintIcon, null),
                        React.createElement("span", null, strings.print))),
                    React.createElement(dropdown_1.Dropdown, { id: "export-dropdown", options: [
                            { text: strings.exportToCsv, action: download, id: "exportToCsv" },
                        ], showOnLeft: true },
                        React.createElement("div", { className: description_styles_1.exportDropdown, id: "download" },
                            React.createElement(download_icon_1.DownloadIcon, null),
                            React.createElement("span", null, strings.exportLabel))))))));
}
exports.Description = Description;
